export function putMedia(url: string, blob: Blob, contentType: string | null,
  progress: (percent: number) => void, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const abort = () => xhr.abort();
    const cleanup = () => signal?.removeEventListener("abort", abort);
    if (signal?.aborted) { reject(new Error("Upload interrupted")); return; }
    xhr.open("PUT", url);
    xhr.timeout = 600000;
    if (contentType) xhr.setRequestHeader("Content-Type", contentType);
    // Never attach HKP auth headers or public-read ACLs to a signed storage request.
    xhr.upload.onprogress = event => {
      if (event.lengthComputable) progress(Math.round(100 * event.loaded / event.total));
    };
    xhr.onload = () => {
      cleanup();
      if (xhr.status >= 200 && xhr.status < 300) { progress(100); resolve(); }
      else reject(new Error("Storage upload failed (" + xhr.status + ")"));
    };
    xhr.onerror = xhr.ontimeout = () => { cleanup(); reject(new Error("Network interrupted; retry the upload")); };
    xhr.onabort = () => { cleanup(); reject(new Error("Upload interrupted")); };
    signal?.addEventListener("abort", abort, { once: true });
    xhr.send(blob);
  });
}
